/* unplugin-vue-components disabled */import script from "./reserved.vue?vue&type=script&setup=true&lang=ts"
export * from "./reserved.vue?vue&type=script&setup=true&lang=ts"

import "./reserved.vue?vue&type=style&index=0&id=4e8eb716&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e8eb716"]])

export default __exports__